exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".msg[data-v-4d7e2c86],.msg-bg[data-v-4d7e2c86]{background-color:#fff}.msg[data-v-4d7e2c86]{border-radius:.5rem}.my-msg[data-v-4d7e2c86]{border-radius:.5rem;background-color:#b0fbd0;border:none}.break-row[data-v-4d7e2c86]{white-space:pre-wrap;word-wrap:break-word}", ""]);

// exports
